import { render, staticRenderFns } from "./AssignPricePopup.vue?vue&type=template&id=532f05fb"
import script from "./AssignPricePopup.vue?vue&type=script&lang=js"
export * from "./AssignPricePopup.vue?vue&type=script&lang=js"
import style0 from "./AssignPricePopup.vue?vue&type=style&index=0&id=532f05fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports